import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { isNullOrWhitespace } from 'src/util/string';

@Component({
  selector: 'tcs-unauthorized-page',
  templateUrl: './unauthorized-page.component.html',
  styleUrls: ['./unauthorized-page.component.scss'],
})
export class UnauthorizedPageComponent implements OnInit {
  public error$: Observable<string | null>;

  constructor(private route: ActivatedRoute) {
    this.error$ = this.route.queryParams.pipe(
      filter((params) => params.error),
      map((params) => {
        if (!isNullOrWhitespace(params.error)) {
          return String(params.error);
        } else {
          return null;
        }
      }),
    );
  }

  public ngOnInit() {}
}
